// src/utils/session.js
import { http } from "../../scripts/api/http.js";
import { setAbilityFromPacked, getAbility } from "./ability.js";
import { setAuth, getAuthData, logout } from "./auth.js";

const RULES_KEY = "irecruit_rules_v1";

export async function initSession() {
	// apply cached rules fast (optional)
	const cached = loadCachedRules();
	if (cached) setAbilityFromPacked(cached);

	try {
		// http.get returns the parsed JSON body OR throws {status, message, data}
		const data = await http.get("/users/me");

		// Expected: { success: true, user: {...}, ability: { version, rules: [...] } }

		console.log("data", data);

		if (!data?.user || !data?.ability?.rules) {
			// unexpected shape -> force re-login
			logout();
			return;
		}

		// keep auth store in sync (role/email might change)
		const auth = getAuthData();
		if (auth?.token) setAuth({ token: auth.token, user: data.user });

		setAbilityFromPacked(data.ability.rules);
		cacheRules(data.ability.rules);

		return { user: data.user, ability: getAbility() };
	} catch (err) {
		// http.js already normalized this error
		console.error("initSession failed:", err);
		if (err.status === 401) {
			logout();
			return;
		}
		// Surface a friendly message or rethrow
		throw new Error(err.message || "Failed to load session");
	}
}

function cacheRules(packed) {
	try {
		localStorage.setItem(RULES_KEY, JSON.stringify(packed));
	} catch {}
}
function loadCachedRules() {
	try {
		return JSON.parse(localStorage.getItem(RULES_KEY));
	} catch {
		return null;
	}
}
